const NORMAL_AD_TYPE = '1';
const IFRAME_AD_TYPE = '2';

const emptyVideoDetails = () => ({ id: '', service: '' });

export const parseDashboardVideo = (value, getVideoId) => {
  const videoUrl = typeof value === 'string' ? value.trim() : '';

  if (!videoUrl) return emptyVideoDetails();

  if (videoUrl.includes('groovevideo')) {
    return { id: videoUrl, service: 'groovevideo' };
  }

  const details = getVideoId(videoUrl);
  if (!details || !details.id || !details.service) return emptyVideoDetails();

  return details;
};

export const isValidDashboardIframeUrl = value => {
  try {
    const parsedUrl = new URL(value);
    return ['http:', 'https:'].includes(parsedUrl.protocol);
  } catch (error) {
    return false;
  }
};

export const buildDashboardSettingPayload = (
  model,
  videoDetails,
  paidVideoDetails
) => {
  const payload = {
    id: model.id,
    is_dashboard_ad_enabled: model.is_dashboard_ad_enabled,
    dashboard_ad_heading: model.dashboard_ad_heading || '',
    dashboard_ad_description: model.dashboard_ad_description || '',
    dashboard_ad_type: model.dashboard_ad_type,
    dashboard_setting_type: model.dashboard_setting_type,
    dashboard_ad_iframe_url: (model.dashboard_ad_iframe_url || '').trim(),
    dashboard_ad_video_provider: videoDetails.service,
    dashboard_ad_video_id: videoDetails.id,
    dashboard_ad_paid_video_provider: paidVideoDetails.service,
    dashboard_ad_paid_video_id: paidVideoDetails.id
  };

  for (let index = 1; index <= 8; index += 1) {
    payload[`dashboard_ad_link${index}_image`] =
      model[`dashboard_ad_link${index}_image`] || '';
    payload[`dashboard_ad_link${index}_title`] =
      model[`dashboard_ad_link${index}_title`] || '';
    payload[`dashboard_ad_link${index}`] =
      model[`dashboard_ad_link${index}`] || '';
    payload[`dashboard_ad_link${index}_display`] =
      model[`dashboard_ad_link${index}_display`] || 0;
  }

  return payload;
};

export const isDashboardAdEnabled = value =>
  value === true || value === 1 || value === '1' || value === 'true';

export const getEffectiveDashboardAdUrl = ({
  dashboardAdData,
  planNames,
  upgradeAdUrl
}) => {
  const isLifetimeMember = planNames
    .filter(Boolean)
    .some(planName => String(planName).toLowerCase().includes('lifetime'));
  const iframeUrl = (
    (dashboardAdData && dashboardAdData.dashboard_ad_iframe_url) ||
    ''
  ).trim();
  const shouldUseLifetimeIframe =
    isLifetimeMember &&
    isDashboardAdEnabled(
      dashboardAdData && dashboardAdData.is_dashboard_ad_enabled
    ) &&
    String(
      dashboardAdData && dashboardAdData.dashboard_setting_type
    ) === IFRAME_AD_TYPE &&
    iframeUrl;

  return shouldUseLifetimeIframe ? iframeUrl : upgradeAdUrl;
};

export const getDashboardSettingValidationMessage = (
  enabled,
  settingType,
  iframeUrl,
  videoDetails
) => {
  if (!enabled) return '';

  if (
    settingType === IFRAME_AD_TYPE &&
    !isValidDashboardIframeUrl(iframeUrl)
  ) {
    return 'Enter a valid http or https iframe URL.';
  }

  if (
    settingType === NORMAL_AD_TYPE &&
    (!videoDetails.id || !videoDetails.service)
  ) {
    return 'Enter a valid GrooveVideo or YouTube URL.';
  }

  return '';
};
